import React, { useEffect, useState } from 'react';

const BuilderEstimateTabs = ({ tabs, active, onTabSelect }) => {
  const [activeTab, setActiveTab] = useState(active);

  useEffect(() => {
    if (active) {
      setActiveTab(active);
    }
  }, [active]);

  const handleTabClick = (tab) => {
    setActiveTab(tab.equipment_category);
    // 1) Call the parent's callback, passing the clicked tab
    if (onTabSelect) {
      onTabSelect(tab);
    }
    // 2) If there's a per-tab onClick, call that too
    if (tab.onClick) {
      tab.onClick();
    }
  };

  return (
    <div className="border-b border-gray-200">
      <nav className="-mb-px flex space-x-8" aria-label="Tabs">
        {tabs.map((tab) => (
          <span
            key={tab.equipment_category}
            className={`flex whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium 
                        hover:cursor-pointer hover:text-blue-700 
                        ${
                          activeTab === tab.equipment_category
                            ? 'border-blue-700 text-blue-700'
                            : 'border-transparent text-gray-500'
                        }`}
            onClick={() => handleTabClick(tab)}
          >
            {tab.equipment_category}
          </span>
        ))}
      </nav>
    </div>
  );
};

export default BuilderEstimateTabs;
